/**
 * Copyright (c) Siemens 2016 - 2026
 * SPDX-License-Identifier: MIT
 */
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SiIconComponent } from '@siemens/element-ng/icon';

import { SiHeaderActionItemBase } from './si-header-action-item.base';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[si-header-selection-item]',
  imports: [SiIconComponent],
  templateUrl: './si-header-selection-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'header-item header-selection-item focus-inside dropdown-toggle',
    '[class.show]': 'open()'
  }
})
export class SiHeaderSelectionItemComponent extends SiHeaderActionItemBase {
  /**
   * Sets the open state which will only affect the arrow. Only use this property when not using {@link SiHeaderDropdownTriggerDirective}.
   *
   * @defaultValue false
   */
  readonly open = input(false);
}
